// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".copyright{font-family:monospace;font-size:12pt}.vps-heart-char{color:#f22;position:relative;font-size:16pt}.vps-heart-char:before{left:1px}.vps-heart-char:after,.vps-heart-char:before{content:\"\";position:absolute;top:4px;border:2px solid #f22;opacity:0;border-radius:50%;width:8px;height:8px;-webkit-animation:sonar 1.5s infinite;animation:sonar 1.5s infinite}.vps-heart-char:after{right:1px}", ""]);
// Exports
module.exports = exports;
